import { Listener } from './Listener';
import { log } from '../InternalLogger';
import { detectFormTest } from '../../helpers/detect-form-test';
import { TrackingHandler } from '../TrackingHandler';
export class LoggerListener extends Listener {
    MINIMUM_DISTANCE_FOR_SCROLL_EVENTS = 20;
    MINIMUM_TIME_BETWEEN_SCROLL_EVENTS = 500;
    MAXIMUM_TIME_BETWEEN_SCROLL_EVENTS = 120000;
    pageLoadTime = 0;
    lastScrollEventTime = 0;
    numQualifiedScrollEvents = 0;
    maximumScrolledPercentage = 0;
    constructor() {
        super();
        this.lastScrollEventTime = this.pageLoadTime = new Date().getTime();
        document.addEventListener('DOMContentLoaded', () => {
            document.querySelectorAll('a, button').forEach((element) => {
                element.addEventListener('click', () => {
                    TrackingHandler.getInstance().softConversion('click');
                });
            });
        });
    }
    formStart(eventId, formName, inputName) {
        log('Form start', {
            eventId,
            formName,
            inputName,
        });
    }
    formNavigate(eventId, formName, formStep, navigationAction, data) {
        log('Form navigate', {
            eventId,
            formName,
            formStep,
            navigationAction,
            data,
        });
    }
    formSubmit(eventId, formName, data) {
        log('Form submit', {
            eventId,
            formName,
            data,
            isTest: detectFormTest(data),
        });
    }
    formSubmitResult(eventId, formName, submitData, statusCode, responseData) {
        if (formName.toLowerCase().includes('consent')) {
            return;
        }
        log('Form submit result', {
            eventId,
            formName,
            status: statusCode,
            isTest: detectFormTest(submitData),
            data: submitData,
            response: responseData,
        });
    }
    chatStart(eventId) {
        log('Chat start', { eventId });
    }
    chatEnd(eventId) {
        log('Chat end', { eventId });
    }
    pageReady(eventId) {
        log('JS loaded', { eventId });
    }
    scrollDistance(eventId, from, fromPercent, to, toPercent, distance, distancePercent, direction, duration, numEvent) {
        const lastScrollEventTime = this.lastScrollEventTime;
        this.lastScrollEventTime = new Date().getTime();
        if (Math.abs(from - to) < this.MINIMUM_DISTANCE_FOR_SCROLL_EVENTS) {
            return;
        }
        if (lastScrollEventTime + this.MINIMUM_TIME_BETWEEN_SCROLL_EVENTS > new Date().getTime()) {
            return;
        }
        if (lastScrollEventTime + this.MAXIMUM_TIME_BETWEEN_SCROLL_EVENTS < new Date().getTime()) {
            return;
        }
        this.numQualifiedScrollEvents++;
        this.checkSoftConversionQualification();
    }
    scrollPercentage(eventId, percent) {
        if (percent > this.maximumScrolledPercentage) {
            this.maximumScrolledPercentage = percent;
        }
    }
    checkSoftConversionQualification() {
        const trackingHandler = TrackingHandler.getInstance();
        if ((this.numQualifiedScrollEvents >= 6 && this.maximumScrolledPercentage > 20) ||
            (this.numQualifiedScrollEvents >= 4 && this.maximumScrolledPercentage > 40) ||
            (this.numQualifiedScrollEvents >= 3 && this.maximumScrolledPercentage > 60)) {
            trackingHandler.softConversion('scroll');
            return;
        }
    }
    softConversion(eventId, source) {
        log('Soft conversion', { eventId, source });
    }
    setConsent(eventId, essential, functional, marketing) {
        if (window.siteSettings.disableCookieConsent) {
            return;
        }
        log('Consent update', {
            eventId,
            essential,
            functional,
            marketing,
        });
    }
    phoneClick(eventId, number, location, elementPath) {
        log('Phone click', { eventId, number, location, elementPath });
    }
    customEvent(eventId, name, data = {}) {
        log('CE: ' + name, { eventId, ...data });
    }
}
